import { AnalyticsEventTopic } from '~/modules/analytics/analyticsHelper';
import { getQueryStringValue } from '~/modules/analytics/gtmEventTypes/gtmEventTypeHelper';
import { GA4LoginNavClickEvent, GtmEventType } from './gtmEventType';

export class GtmLoginNavClickType extends GtmEventType {
    // @ts-expect-error * Automated Type Error Fix
    canHandle(event): boolean {
        return event.topic === AnalyticsEventTopic.ANALYTICS_CLICK && event.elementType === 'loginNavLink';
    }

    getNavType(menuItem: string): string {
        const [parentMenu] = menuItem.split(':');

        switch (parentMenu) {
            case 'waffle':
                return 'waffle';

            case 'user menu':
                return 'login';

            default:
                return parentMenu;
        }
    }

    // @ts-expect-error * Automated Type Error Fix
    getBody(event): GA4LoginNavClickEvent {
        const { navLevel, menuItem, clickText, clickUrl, destinationType, ctaClick } = event?.navLink || {};
        return {
            event: 'custEv_navigationClick',
            nav_level: navLevel,
            nav_item: menuItem,
            click_text: clickText,
            click_url: clickUrl,
            internal_driver: getQueryStringValue(clickUrl, 'd'),
            element_type: clickUrl ? 'link' : 'button',
            nav_type: this.getNavType(menuItem),
        };
    }
}
